import React, { Component } from 'react';

import { Row, Col, Card } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';
import LazyLoad from 'react-lazyload';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/Introduction/IntroText.css";

// Images

import chooseOne    from "../../../Imgs/AboutUs/Introduction/choose1.svg";
import chooseTwo    from "../../../Imgs/AboutUs/Introduction/choose2.svg";
import chooseThree  from "../../../Imgs/AboutUs/Introduction/choose3.svg";
import chooseFour   from "../../../Imgs/AboutUs/Introduction/choose4.svg";
import chooseFive   from "../../../Imgs/AboutUs/Introduction/choose5.svg";
import chooseSix    from "../../../Imgs/AboutUs/Introduction/choose6.svg";
import chooseSeven  from "../../../Imgs/AboutUs/Introduction/choose7.svg";
import chooseEight  from "../../../Imgs/AboutUs/Introduction/choose8.svg";
import chooseNine   from "../../../Imgs/AboutUs/Introduction/choose9.svg";
import chooseTen    from "../../../Imgs/AboutUs/Introduction/choose10.svg";


const featureText = {
    fontFamily: "IranSans",
    color: "#8d8d8d",
    fontSize: ".95em",
    textAlign: "center",
    direction: "rtl",
}
const featureTextMobile = {
    fontFamily: "IranSans",
    color: "#8d8d8d",
    fontSize: ".9em",
    textAlign: "center",
    direction: "rtl",
    marginTop:"-10px"
}
const featureCard = {
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    borderRadius: "10px",
    margin: "10px",
    height:"250px",
}
const featureCardMobile = {
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    borderRadius: "10px",
    margin: "10px",
    height: "200px",
}
const ChooseUS = props => {

    return props.size === "laptopdesktop" ? (
        <div style={{ backgroundColor: "#ffffff" }}>
            <Center>
                <Margin top={5}>
                    <div>
                        <p className="subTitle"><strong>چرا باید ما را انتخاب کنید</strong></p>
                    </div>
                </Margin>
            </Center>
            <Center>
                <div className="subTitleHR"></div>
            </Center>
            <Row>
                <Col span={1}></Col>
                <Col span={22}>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={4}>
                            <Card style={featureCard}>
                                <Center>
                                    <div>
                                        <figure>
                                            <LazyLoad>
                                            <img
                                                className="serviceLogo iconHoverEffect"
                                                src={chooseFive}
                                            />
                                                </LazyLoad>
                                        </figure>
                                    </div>
                                </Center>
                                <Center>
                                    <p style={featureText}>
                                        تنها شرکت دارای امتیاز رسانه رسمی در صنعت بیمه 
                                    </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={4}>
                            <Card style={featureCard}>
                                <Center>
                                    <div>
                                        <figure>
                                            <LazyLoad>
                                            <img
                                                className="serviceLogo iconHoverEffect"
                                                src={chooseFour}
                                            />
                                                </LazyLoad>
                                        </figure>
                                    </div>
                                </Center>
                                <Center>
                                    <p style={featureText}>
                                        تنها شرکت دارای موسسه داوری در دعاوی قراردادهای بیمه ای
                                    </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={4}>
                            <Card style={featureCard}>
                                <Center>
                                    <div>
                                        <figure>
                                            <LazyLoad>
                                            <img
                                                className="serviceLogo iconHoverEffect"
                                                src={chooseThree}
                                            />
                                                </LazyLoad>
                                        </figure>
                                    </div>
                                </Center>
                                <Center>
                                    <p style={featureText}>
                                        تنها شرکت دارای مجوز آموزش از بیمه مرکزی در حوزه ارزیابی خسارت 
                                    </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={4}>
                            <Card style={featureCard}>
                                <Center>
                                    <div>
                                        <figure>
                                            <LazyLoad>
                                            <img
                                                className="serviceLogo iconHoverEffect"
                                                src={chooseTwo}
                                            />
                                                </LazyLoad>
                                        </figure>
                                    </div>
                                </Center>
                                <Center>
                                    <p style={featureText}>
                                        تنها شرکت دارای تلفن رند چهار رقمی بدون کد، پاسخگویی ۲۴ ساعته و بدون تعطیلی در سراسر کشور 
                                    </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={4}>
                            <Card style={featureCard}>
                                <Center>
                                    <div>
                                        <figure>
                                            <LazyLoad>
                                            <img
                                                className="serviceLogo iconHoverEffect"
                                                src={chooseOne}
                                            />
                                                </LazyLoad>
                                        </figure>
                                    </div>
                                </Center>
                                <Center>
                                    <p style={featureText}>
                                        تنها شرکت جامع ارزیابی ریسک و خسارت در کلیه حوزه های بیمه
                                    </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={1}></Col>
                    </Row>
                </Col>
                <Col span={2}></Col>
            </Row>
            <Margin top={3}></Margin>
            <Row>
                <Col span={1}></Col>
                <Col span={22}>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={4}>
                            <Card style={featureCard}>
                                <Center>
                                    <div>
                                        <figure>
                                            <LazyLoad>
                                            <img
                                                className="serviceLogo iconHoverEffect"
                                                src={chooseTen}
                                            />
                                                </LazyLoad>
                                        </figure>
                                    </div>
                                </Center>
                                <Center>
                                    <p style={featureText}>
                                        تنها شرکت ارزیابی دارای آموزشگاه فنی و حرفه ای 
                                    </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={4}>
                            <Card style={featureCard}>
                                <Center>
                                    <div>
                                        <figure>
                                            <LazyLoad>
                                            <img
                                                className="serviceLogo iconHoverEffect"
                                                src={chooseNine}
                                            />
                                                </LazyLoad>
                                        </figure>
                                    </div>
                                </Center>
                                <Center>
                                    <p style={featureText}>
                                        تنها شرکت  دارای مجوز از سازمان نظام صنفی رایانه ای کشور 
                                    </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={4}>
                            <Card style={featureCard}>
                                <Center>
                                    <div>
                                        <figure>
                                            <LazyLoad>
                                            <img
                                                className="serviceLogo iconHoverEffect"
                                                src={chooseEight}
                                            />
                                                </LazyLoad>
                                        </figure>
                                    </div>
                                </Center>
                                <Center>
                                    <p style={featureText}>
                                        تنها شرکت دارای مجوز وکالت برای بیمه گران در صنعت بیمه 
                                    </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={4}>
                            <Card style={featureCard}>
                                <Center>
                                    <div>
                                        <figure>
                                            <LazyLoad>
                                            <img
                                                className="serviceLogo iconHoverEffect"
                                                src={chooseSeven}
                                            />
                                                </LazyLoad>
                                        </figure>
                                    </div>
                                </Center>
                                <Center>
                                    <p style={featureText}>
                                        تنها شرکت دارای موسسه افسران تحقیق
                                    </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={4}>
                            <Card style={featureCard}>
                                <Center>
                                    <div>
                                        <figure>
                                            <LazyLoad>
                                            <img
                                                className="serviceLogo iconHoverEffect"
                                                src={chooseSix}
                                            />
                                                </LazyLoad>
                                        </figure>
                                    </div>
                                </Center>
                                <Center>
                                    <p style={featureText}>
                                        تنها شرکت دارای موسسه اکچوئری و داده کاوی 
                                    </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={1}></Col>
                    </Row>
                </Col>
                <Col span={2}></Col>
            </Row>
        </div>
    ) : props.size === "tablet" ? (
        <div style={{ backgroundColor: "#ffffff" }}>
            <Center>
                <Margin top={5}>
                    <div>
                        <p className="subTitleTablet"><strong>چرا باید ما را انتخاب کنید</strong></p>
                    </div>
                </Margin>
            </Center>
            <Center>
                <hr className="subTitleHRTablet" />
            </Center>
            <Row>
                <Col span={2}></Col>
                <Col span={10}>
                        <Card style={featureCardMobile}>
                            <Center>
                                <figure>
                                    <LazyLoad>
                                    <img
                                        style={{ width: "125px" }}
                                        className="iconHoverEffect"
                                        src={chooseTwo}
                                    />
                                        </LazyLoad>
                                </figure>
                            </Center>
                            <Center>
                                <p style={featureTextMobile}>
                                    تنها شرکت دارای تلفن رند چهار رقمی بدون کد، پاسخگویی ۲۴ ساعته و بدون تعطیلی در سراسر کشور 
                            </p>
                            </Center>
                        </Card>
                </Col>
                <Col span={10}>
                        <Card style={featureCardMobile}>
                            <Center>
                                <figure>
                                    <LazyLoad>
                                    <img
                                        style={{ width: "125px" }}
                                        className="iconHoverEffect"
                                        src={chooseOne}
                                    />
                                        </LazyLoad>
                                </figure>
                            </Center>
                            <Center>
                                <p style={featureTextMobile}>
                                    تنها شرکت جامع ارزیابی ریسک و خسارت در کلیه حوزه های بیمه
                        </p>
                            </Center>
                        </Card>
                </Col>
                <Col span={2}></Col>
            </Row>
            <Row>
                <Col span={2}></Col>
                <Col span={10}>
                        <Card style={featureCardMobile}>
                            <Center>
                                <figure>
                                    <LazyLoad>
                                    <img
                                        style={{ width: "125px" }}
                                        className="iconHoverEffect"
                                        src={chooseFour}
                                    />
                                        </LazyLoad>
                                </figure>
                            </Center>
                            <Center>
                                <p style={featureTextMobile}>
                                    تنها شرکت دارای موسسه داوری در دعاوی قراردادهای بیمه ای
                            </p>
                            </Center>
                        </Card>
                </Col>
                <Col span={10}>
                        <Card style={featureCardMobile}>
                            <Center>
                                <figure>
                                    <LazyLoad>
                                    <img
                                        style={{ width: "125px" }}
                                        className="iconHoverEffect"
                                        src={chooseThree}
                                    />
                                        </LazyLoad>
                                </figure>
                            </Center>
                            <Center>
                                <p style={featureTextMobile}>
                                    تنها شرکت دارای مجوز آموزش از بیمه مرکزی در حوزه ارزیابی خسارت
                            </p>
                            </Center>
                        </Card>
                </Col>
                <Col span={2}></Col>
            </Row>
            <Row>
                <Col span={2}></Col>
                <Col span={10}>
                        <Card style={featureCardMobile}>
                            <Center>
                                <figure>
                                    <LazyLoad>
                                    <img
                                        style={{ width: "125px" }}
                                        className="iconHoverEffect"
                                        src={chooseSix}
                                    />
                                        </LazyLoad>
                                </figure>
                            </Center>
                            <Center>
                                <p style={featureTextMobile}>
                                    تنها شرکت دارای موسسه اکچوئری و داده کاوی
                                </p>
                            </Center>
                        </Card>
                </Col>
                <Col span={10}>
                        <Card style={featureCardMobile}>
                            <Center>
                                <figure>
                                    <LazyLoad>
                                    <img
                                        style={{ width: "125px" }}
                                        className="iconHoverEffect"
                                        src={chooseFive}
                                    />
                                        </LazyLoad>
                                </figure>
                            </Center>
                            <Center>
                                <p style={featureTextMobile}>
                                    تنها شرکت دارای امتیاز رسانه رسمی در صنعت بیمه
                            </p>
                            </Center>
                        </Card>
                </Col>
                <Col span={2}></Col>
            </Row>
            <Row>
                <Col span={2}></Col>
                <Col span={10}>
                        <Card style={featureCardMobile}>
                            <Center>
                                <figure>
                                    <LazyLoad>
                                    <img
                                        style={{ width: "125px" }}
                                        className="iconHoverEffect"
                                        src={chooseEight}
                                    />
                                        </LazyLoad>
                                </figure>
                            </Center>
                            <Center>
                                <p style={featureTextMobile}>
                                    تنها شرکت دارای مجوز وکالت برای بیمه گران در صنعت بیمه
                                    </p>
                            </Center>
                        </Card>
                </Col>
                <Col span={10}>
                        <Card style={featureCardMobile}>
                            <Center>
                                <figure>
                                    <LazyLoad>
                                    <img
                                        style={{ width: "125px" }}
                                        className="iconHoverEffect"
                                        src={chooseSeven}
                                    />
                                        </LazyLoad>
                                </figure>
                            </Center>
                            <Center>
                                <p style={featureTextMobile}>
                                    تنها شرکت دارای موسسه افسران تحقیق
                                    </p>
                            </Center>
                        </Card>
                </Col>
                <Col span={2}></Col>
            </Row>
            <Row>
                <Col span={2}></Col>
                <Col span={10}>
                        <Card style={featureCardMobile}>
                            <Center>
                                <figure>
                                    <LazyLoad>
                                    <img
                                        style={{ width: "125px" }}
                                        className="iconHoverEffect"
                                        src={chooseTen}
                                    />
                                        </LazyLoad>
                                </figure>
                            </Center>
                            <Center>
                                <p style={featureTextMobile}>
                                    تنها شرکت ارزیابی دارای آموزشگاه فنی و حرفه ای
                                </p>
                            </Center>
                        </Card>
                </Col>
                <Col span={10}>
                        <Card style={featureCardMobile}>
                            <Center>
                                <figure>
                                    <LazyLoad>
                                    <img
                                        style={{ width: "125px" }}
                                        className="iconHoverEffect"
                                        src={chooseNine}
                                    />
                                        </LazyLoad>
                                </figure>
                            </Center>
                            <Center>
                                <p style={featureTextMobile}>
                                    تنها شرکت  دارای مجوز از سازمان نظام صنفی رایانه ای کشور
                                    </p>
                            </Center>
                        </Card>
                </Col>
                <Col span={2}></Col>
            </Row>
        </div>
    ) : (
            <div>
                <div style={{ backgroundColor: "#ffffff" }}>
                    <Center>
                        <Margin top={5}>
                            <div>
                                <p className="subTitleMobile"><strong>چرا باید ما را انتخاب کنید</strong></p>
                            </div>
                        </Margin>
                    </Center>
                    <Center>
                        <div className="subTitleHRMobile"></div>
                    </Center>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={20}>
                            <Card style={featureCardMobile}>
                                <Center>
                                    <figure>
                                            <LazyLoad>
                                        <img
                                            style={{ width: "100px" }}
                                            className="iconHoverEffect"
                                            src={chooseOne}
                                        />
                                                </LazyLoad>
                                    </figure>
                                </Center>
                                <Center>
                                    <p style={featureTextMobile}>
                                        تنها شرکت جامع ارزیابی ریسک و خسارت در کلیه حوزه های بیمه
                                </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={2}></Col>
                    </Row>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={20}>
                            <Card style={featureCardMobile}>
                                <Center>
                                    <figure>
                                            <LazyLoad>
                                        <img
                                            style={{ width: "100px" }}
                                            className="iconHoverEffect"
                                            src={chooseTwo}
                                        />
                                                </LazyLoad>
                                    </figure>
                                </Center>
                                <Center>
                                    <p style={featureTextMobile}>
                                        تنها شرکت دارای تلفن رند چهار رقمی بدون کد، پاسخگویی ۲۴ ساعته و بدون تعطیلی در سراسر کشور 
                                </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={2}></Col>
                    </Row>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={20}>
                            <Card style={featureCardMobile}>
                                <Center>
                                    <figure>
                                            <LazyLoad>
                                        <img
                                            style={{ width: "100px" }}
                                            className="iconHoverEffect"
                                            src={chooseThree}
                                        />
                                                </LazyLoad>
                                    </figure>
                                </Center>
                                <Center>
                                    <p style={featureTextMobile}>
                                        تنها شرکت دارای مجوز آموزش از بیمه مرکزی در حوزه ارزیابی خسارت 
                                </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={2}></Col>
                    </Row>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={20}>
                            <Card style={featureCardMobile}>
                                <Center>
                                    <figure>
                                            <LazyLoad>
                                        <img
                                            style={{ width: "100px" }}
                                            className="iconHoverEffect"
                                            src={chooseFour}
                                        />
                                                </LazyLoad>
                                    </figure>
                                </Center>
                                <Center>
                                    <p style={featureTextMobile}>
                                        تنها شرکت دارای موسسه داوری در دعاوی قراردادهای بیمه ای
                                </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={2}></Col>
                    </Row>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={20}>
                            <Card style={featureCardMobile}>
                                <Center>
                                    <figure>
                                            <LazyLoad>
                                        <img
                                            style={{ width: "100px" }}
                                            className="iconHoverEffect"
                                            src={chooseFive}
                                        />
                                                </LazyLoad>
                                    </figure>
                                </Center>
                                <Center>
                                    <p style={featureTextMobile}>
                                        تنها شرکت دارای امتیاز رسانه رسمی در صنعت بیمه 
                                </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={2}></Col>
                    </Row>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={20}>
                            <Card style={featureCardMobile}>
                                <Center>
                                    <figure>
                                            <LazyLoad>
                                        <img
                                            style={{ width: "100px" }}
                                            className="iconHoverEffect"
                                            src={chooseSix}
                                        />
                                                </LazyLoad>
                                    </figure>
                                </Center>
                                <Center>
                                    <p style={featureTextMobile}>
                                        تنها شرکت دارای موسسه اکچوئری و داده کاوی 
                                    </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={2}></Col>
                    </Row>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={20}>
                            <Card style={featureCardMobile}>
                                <Center>
                                    <figure>
                                            <LazyLoad>
                                        <img
                                            style={{ width: "100px" }}
                                            className="iconHoverEffect"
                                            src={chooseSeven}
                                        />
                                                </LazyLoad>
                                    </figure>
                                </Center>
                                <Center>
                                    <p style={featureTextMobile}>
                                        تنها شرکت دارای موسسه افسران تحقیق
                                    </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={2}></Col>
                    </Row>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={20}>
                            <Card style={featureCardMobile}>
                                <Center>
                                    <figure>
                                            <LazyLoad>
                                        <img
                                            style={{ width: "100px" }}
                                            className="iconHoverEffect"
                                            src={chooseEight}
                                        />
                                                </LazyLoad>
                                    </figure>
                                </Center>
                                <Center>
                                    <p style={featureTextMobile}>
                                        تنها شرکت دارای مجوز وکالت برای بیمه گران در صنعت بیمه 
                                    </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={2}></Col>
                    </Row>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={20}>
                            <Card style={featureCardMobile}>
                                <Center>
                                    <figure>
                                            <LazyLoad>
                                        <img
                                            style={{ width: "100px" }}
                                            className="iconHoverEffect"
                                            src={chooseNine}
                                        />
                                                </LazyLoad>
                                    </figure>
                                </Center>
                                <Center>
                                    <p style={featureTextMobile}>
                                        تنها شرکت  دارای مجوز از سازمان نظام صنفی رایانه ای کشور 
                                    </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={2}></Col>
                    </Row>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={20}>
                            <Card style={featureCardMobile}>
                                <Center>
                                    <figure>
                                            <LazyLoad>
                                        <img
                                            style={{ width: "100px" }}
                                            className="iconHoverEffect"
                                            src={chooseTen}
                                        />
                                                </LazyLoad>
                                    </figure>
                                </Center>
                                <Center>
                                    <p style={featureTextMobile}>
                                        تنها شرکت ارزیابی دارای آموزشگاه فنی و حرفه ای 
                                    </p>
                                </Center>
                            </Card>
                        </Col>
                        <Col span={2}></Col>
                    </Row>
                    
                </div>
            </div>
        );
};

export default ChooseUS;
